// Textos de los ajustes de anuncios por zona (zone-ad-settings). Se registran junto al
// resto de vocabularios en AppComponent; setTranslation los fusiona.
export const locale = {
  lang: 'en',
  data: {
    ZONE_AD_SETTINGS: {
      TITLE: 'Zone ad settings',
      NOTE_TITLE: 'Ad drafts for zones without matches',
      NOTE_TEXT:
        'Every so often, routines that have gone without a match for a while are looked up and a Meta ad draft is prepared for their zone (an H3 cell). Here you decide when that happens, which values each draft starts with and which details it is published with.',
      LOADING: 'Loading settings…',
      ERROR_LOAD: 'The zone ad settings could not be loaded.',
      ERROR_FORBIDDEN: "You don't have permission to view the zone ad settings.",
      RETRY: 'Retry',

      GENERAL_TITLE: 'Automatic generation',
      GENERAL_SUB: 'When off, no new drafts are created.',
      ENABLED_LABEL: 'Generate drafts automatically',

      GENERATION_TITLE: 'Which zones are included',
      GENERATION_SUB: 'Zone size and which routines and zones are taken into account in each run.',
      H3_RESOLUTION: 'H3 resolution',
      H3_RESOLUTION_HINT: 'Cell size of each zone, from 0 (largest) to 15 (smallest).',
      NO_MATCH_HOURS: 'Hours without a match',
      NO_MATCH_HOURS_HINT: 'Hours a routine must go without a match to count, from 1 to 87,600.',
      COOLDOWN_DAYS: 'Waiting days per zone',
      COOLDOWN_DAYS_HINT: 'Days a zone waits, after its last draft is closed, before getting another one. From 0 to 365.',
      SCHEDULE_LABEL: 'When it runs',
      SCHEDULE_TIMES: 'At fixed times',
      SCHEDULE_EVERY: 'Every N hours',
      EVERY_HOURS_LABEL: 'Interval',
      EVERY_HOURS_ONE: 'Every hour',
      EVERY_HOURS_OTHER: 'Every {{count}} hours',
      TIME_ARIA: 'Time {{n}}',
      ADD_TIME: 'Add time',
      REMOVE_TIME: 'Remove this time',
      SCHEDULE_HINT: 'Madrid time.',

      DEFAULTS_TITLE: 'Values of each draft',
      DEFAULTS_SUB: 'Each generated draft starts with these values.',
      RADIUS_KM: 'Radius (km)',
      RADIUS_KM_HINT: 'Ad radius, from 1 to 80 km.',
      BUDGET: 'Budget (€)',
      BUDGET_HINT: 'Total campaign budget.',
      DURATION_DAYS: 'Duration (days)',
      DURATION_DAYS_HINT: 'Days the campaign lasts, from 1 to 90.',
      BUDGET_MINIMUM: 'With these values, the budget must be at least {{min}} (Meta minimum per platform and day × 2 platforms × days).',
      ADVANTAGE_DEFAULT: 'Meta Advantage+ audience by default in new drafts',
      ADVANTAGE_HINT: 'Meta may broaden age and interests to improve performance; the zone is still a limit. Each draft can be changed while it is a draft.',

      META_TITLE: 'Publishing on Meta',
      META_SUB: 'Details sent to Meta with each ad.',
      DSA_MISSING: 'Without a payor and a beneficiary no draft can be published on Meta.',
      LANDING_URL: 'Landing page',
      LANDING_URL_HINT: 'Where the ad leads to. It must start with https://',
      DSA_PAYOR: 'Payor (DSA)',
      DSA_PAYOR_HINT: 'Who pays for the ads, under the EU Digital Services Act.',
      DSA_BENEFICIARY: 'Beneficiary (DSA)',
      DSA_BENEFICIARY_HINT: 'On whose behalf the ads are run.',
      MIN_BUDGET_PER_DAY: 'Meta minimum budget per platform and day (€)',
      MIN_BUDGET_PER_DAY_HINT: 'What Meta requires for each ad set (Facebook and Instagram) per day.',

      UPDATED_AT: 'Last modified',
      SAVE: 'Save changes',
      SAVING: 'Saving…',
      SAVE_DISABLED_HINT: 'Review the highlighted fields to be able to save',
      SAVED: 'Settings saved',
      ERROR_SAVE: 'The settings could not be saved',
      ERROR_FORBIDDEN_SAVE: "You don't have permission to change the zone ad settings",
      ACCEPT: 'OK',

      VALIDATION: {
        REQUIRED: 'This field is required.',
        INTEGER: 'It must be a whole number.',
        RANGE: 'It must be between {{min}} and {{max}}.',
        MIN_BUDGET: 'The minimum is {{min}}.',
        MAX_BUDGET: 'The maximum is {{max}}.',
        EURO_CENTS: 'Two decimals at most.',
        HTTPS_URL: 'It must be an address starting with https://',
        MAX_LENGTH: '{{max}} characters at most.',
        TIMES_REQUIRED: 'Add at least one time.',
        TIME_FORMAT: 'Format HH:MM.',
      },
    },
  },
};
